function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Finds the index in orderedIds of the closest following node that is visible (show === true)
 * @returns The index of that node
 */
export var getNextVisibleNodeIndex = function getNextVisibleNodeIndex(_ref) {
  var currentNodeId = _ref.currentNodeId,
    orderedIds = _ref.orderedIds,
    normalizedTree = _ref.normalizedTree;
  var initialIndex = orderedIds.findIndex(function (x) {
    return x === currentNodeId;
  });
  for (var i = initialIndex + 1; i < orderedIds.length; i++) {
    var nextNodeId = orderedIds[i];
    if (normalizedTree[nextNodeId].show) {
      return i;
    }
  }
  return -1;
};

/**
 * Finds the index in orderedIds of the closest previous node that is visible (show === true)
 * @returns The index of that node
 */
export var getPreviousVisibleNodeIndex = function getPreviousVisibleNodeIndex(_ref2) {
  var currentNodeId = _ref2.currentNodeId,
    orderedIds = _ref2.orderedIds,
    normalizedTree = _ref2.normalizedTree;
  var initialIndex = orderedIds.findIndex(function (x) {
    return x === currentNodeId;
  });
  for (var i = initialIndex - 1; i >= 0; i--) {
    var previousNodeId = orderedIds[i];
    if (normalizedTree[previousNodeId].show) {
      return i;
    }
  }
  return -1;
};
export var getLastVisibleNode = function getLastVisibleNode(_ref3) {
  var orderedIds = _ref3.orderedIds,
    normalizedTree = _ref3.normalizedTree;
  for (var i = orderedIds.length - 1; i > 0; i--) {
    var node = normalizedTree[orderedIds[i]];
    if (node.show) {
      return node;
    }
  }
  return undefined;
};
export var getLastDescendant = function getLastDescendant(_ref4) {
  var node = _ref4.node,
    normalizedTree = _ref4.normalizedTree;
  var currentNode = node;
  while ((_currentNode$childIds = currentNode.childIds) !== null && _currentNode$childIds !== void 0 && _currentNode$childIds.length) {
    var _currentNode$childIds;
    currentNode = normalizedTree[currentNode.childIds[currentNode.childIds.length - 1]];
  }
  return currentNode;
};
export var relocateSubArray = function relocateSubArray(_ref5) {
  var arr = _ref5.arr,
    startIndex = _ref5.startIndex,
    endIndex = _ref5.endIndex,
    targetIndex = _ref5.targetIndex;
  var preSourceIds = arr.slice(0, startIndex);
  var sourceIds = arr.slice(startIndex, endIndex + 1);
  var postSourceIds = arr.slice(endIndex + 1);
  var sourceSubtractedFromArr = [].concat(_toConsumableArray(preSourceIds), _toConsumableArray(postSourceIds));
  var isMoveDown = startIndex < targetIndex;
  var targetIndexOffset = isMoveDown ? -1 : 0;
  var preTargetIds = sourceSubtractedFromArr.slice(0, targetIndex + targetIndexOffset);
  var postTargetIds = sourceSubtractedFromArr.slice(targetIndex + targetIndexOffset);
  return [[].concat(_toConsumableArray(preTargetIds), _toConsumableArray(sourceIds), _toConsumableArray(postTargetIds)), sourceIds];
};
export var checkIsDescendant = function checkIsDescendant(_ref6) {
  var node = _ref6.node,
    potentialDescendantNode = _ref6.potentialDescendantNode,
    normalizedTree = _ref6.normalizedTree;
  var nodes = [node];
  while (nodes.length) {
    var _currentNode$childIds2;
    var currentNode = nodes.pop();
    if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.id) === potentialDescendantNode.id) {
      return true;
    }
    var childNodes = currentNode === null || currentNode === void 0 ? void 0 : (_currentNode$childIds2 = currentNode.childIds) === null || _currentNode$childIds2 === void 0 ? void 0 : _currentNode$childIds2.map(function (id) {
      return normalizedTree[id];
    });
    if (childNodes !== null && childNodes !== void 0 && childNodes.length) {
      nodes = nodes.concat(childNodes);
    }
  }
  return false;
};
//# sourceMappingURL=helpers.js.map